import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import vi from "./vi.json";

export const SUPPORTED_LOCALES = ["vi", "en"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export function detectLocale(): Locale {
  const saved = typeof localStorage === "undefined" ? null : localStorage.getItem("saa_locale");
  if (saved === "vi" || saved === "en") return saved;
  return typeof navigator !== "undefined" && navigator.language.startsWith("en") ? "en" : "vi";
}

// Không có fallback tiếng Anh âm thầm: thiếu khoá ở locale nào thì cổng check-i18n-keys bắt.
void i18next.use(initReactI18next).init({
  resources: { vi: { translation: vi }, en: { translation: en } },
  lng: detectLocale(),
  fallbackLng: false,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18next;
